// import React from "react";
// import { FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaPhoneAlt } from "react-icons/fa";
// import { Link } from "react-router-dom";

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   return (
//     <footer className="bg-gray-100 text-gray-800 border-t border-gray-300">
//       <div className="container mx-auto px-4 py-8">
//         {/* Main footer content */}
//         <div className="flex flex-col md:flex-row max-md:items-center justify-between mb-6 px-0 md:px-6">
//           {/* Company info */}
//           <div className="mb-6 md:mb-0">
//             <h3 className="font-bold max-md:text-center text-[#730000] text-lg mb-3 font-serif cursor-default">
//               Select Proposal
//             </h3>
//             <p className="text-sm text-gray-600 max-w-xs cursor-default">
//               Helping you find the proposal of your dreams 
//             </p>
            
//           </div>
//           <div className="flex flex-col mb-6 max-md:items-center justify-center items-center">
//             <img
//               src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/State_emblem_of_Pakistan.svg/330px-State_emblem_of_Pakistan.svg.png"
//               alt=""
//               className="w-[102px] flex flex-col max-md:items-start justify-center items-center"
//             />
//             <p className="text-sm text-gray-600 max-w-xs cursor-default mt-4">
//               {" "}
//               Registered with Govt of Pakistan
//             </p>
//           </div>

//           {/* Navigation links */}
//           <div className="grid grid-cols-2 md:grid-cols- gap-8 pl-0 md:pl-[5.2rem]">
//             <div>
//               <h4 className="font-semibold mb-3 font-playfair cursor-default">
//                 Company
//               </h4>
//               <ul className="space-y-2 text-sm">
//                 <li>
//                   <Link to="/about" className="hover:text-blue-600 transition">
//                     About us
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/blogs" className="hover:text-blue-600 transition">
//                     Blog
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     to="/contact"
//                     className="hover:text-blue-600 transition"
//                   >
//                     Contact us
//                   </Link>
//                 </li>
//               </ul>
//             </div>
//             <div>
//               <h4 className="font-semibold mb-3 font-playfair cursor-default">
//                 Legal
//               </h4>
//               <ul className="space-y-2 text-sm">
//                 <li>
//                   <Link
//                     to="/termAndConditions"
//                     className="hover:text-blue-600 transition"
//                   >
//                     Terms of Use
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     to="/termAndConditions"
//                     className="hover:text-blue-600 transition"
//                   >
//                     Privacy Policy
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     to="/refund-policy"
//                     className="hover:text-blue-600 transition"
//                   >
//                     Refund Policy
//                   </Link>
//                 </li>
//               </ul>
//             </div>
//             {/* <div>
//               <h4 className="font-semibold mb-3 font-playfair">Support</h4>
//               <ul className="space-y-2 text-sm">
//                 <li>
//                   <Link
//                     to="/support"
//                     className="hover:text-blue-600 transition"
//                   >
//                     Help Center
//                   </Link>
//                 </li>
//               </ul>
//             </div> */}
//           </div>
//         </div>

//         {/* Social media and copyright */}
//         <div className="border-t border-gray-200 pt-6 mt-6 px-6">
//           <div className="flex flex-col md:flex-row md:justify-between items-center">
//             <div className="flex space-x-4 mb-4 md:mb-0">
//               <Link
//                 to="https://www.facebook.com/selectproposal/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 aria-label="Facebook"
//                 className="text-gray-600 hover:text-blue-600 transition"
//               >
//                 <FaFacebook size={24} />
//               </Link>
//               <Link
//                 to="https://www.instagram.com/selectproposal/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 aria-label="Instagram"
//                 className="text-gray-600 hover:text-pink-600 transition"
//               >
//                 <FaInstagram size={24} />
//               </Link>
//             </div>
//             <p className="text-sm text-gray-600 cursor-default">
//               © {currentYear} selectproposal.com All rights reserved.
//             </p>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaHeart,
  FaGooglePlay,
  FaPhoneAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useSiteSettings } from "../../utils/SiteSettingsContext";

const Footer = () => {
  const { contactChannel, whatsappEnabled, callNumber, callLink, callEnabled } = useSiteSettings();
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="bg-[#1a0505] text-[#ccc] pt-20 pb-5 text-sm">
        <div className="max-w-[1200px] mx-auto px-5">
          {/* Footer Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1.2fr] gap-10 mb-16">
            {/* Brand Section */}
            <div className="footer-brand">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-white font-playfair text-xl font-bold mb-5"
              >
                <FaHeart className="text-[#a30000]" />
                <span>Select Proposal</span>
              </Link>
              <p className="leading-relaxed max-w-[300px] mb-5 text-[#ccc]">
                The premier matrimonial service dedicated to Pakistani culture,
                helping you find a proposal that aligns with your values,
                career, and life goals.
              </p>
              <div className="flex gap-4">
                <a
                  href="https://www.instagram.com/selectproposal/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 border border-[#444] rounded-full flex items-center justify-center text-[#ccc] hover:bg-[#a30000] hover:border-[#a30000] hover:text-white transition-all duration-300"
                  aria-label="Instagram"
                >
                  <FaInstagram size={16} />
                </a>
                {whatsappEnabled && (
                  <a
                    href={contactChannel().href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-9 h-9 border border-[#444] rounded-full flex items-center justify-center text-[#ccc] hover:bg-[#a30000] hover:border-[#a30000] hover:text-white transition-all duration-300"
                    aria-label="WhatsApp"
                  >
                    <FaWhatsapp size={16} />
                  </a>
                )}
                <a
                  href="https://www.facebook.com/selectproposal/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 border border-[#444] rounded-full flex items-center justify-center text-[#ccc] hover:bg-[#a30000] hover:border-[#a30000] hover:text-white transition-all duration-300"
                  aria-label="Facebook"
                >
                  <FaFacebook size={16} />
                </a>
              </div>

              <a
                href="https://play.google.com/store/apps/details?id=com.selectproposal.app"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-3 px-4 py-2.5 border border-[#444] rounded-lg text-[#ccc] hover:bg-black hover:text-white hover:border-[#666] transition-all duration-300"
                aria-label="Download the Select Proposal app on Google Play"
              >
                <FaGooglePlay size={20} />
                <span className="text-left leading-tight">
                  <span className="block text-[10px] uppercase tracking-wider opacity-70">Get it on</span>
                  <span className="block text-sm font-semibold text-white">Google Play</span>
                </span>
              </a>
            </div>

            {/* Company Links */}
            <div>
              <h4 className="text-white font-sans text-base font-semibold mb-5">
                Company
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/about"
                    className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/blogs"
                    className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                  >
                    Blogs
                  </Link>
                </li>
                <li>
                  <Link
                    to="/pricing"
                    className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                  >
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link
                    to="/faq"
                    className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                  >
                    FAQ
                  </Link>
                </li>
                <li>
                  <Link
                    to="/partners/apply"
                    className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                  >
                    Partner Program
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal Links */}
            <div>
              <h4 className="text-white font-sans text-base font-semibold mb-5">
                Legal
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/privacy-policy"
                    className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/termAndConditions"
                    className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                  >
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link
                    to="/refund-policy"
                    className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                  >
                    Refund Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/cancellation-policy"
                    className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                  >
                    Cancellation Policy
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div>
              <h4 className="text-white font-sans text-base font-semibold mb-5">
                Get in Touch
              </h4>
              <p className="mb-2.5 flex items-center gap-2">
                {whatsappEnabled ? (
                  <>
                    <FaWhatsapp className="text-[#25D366]" />
                    <a
                      href={contactChannel().href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                    >
                      Message us on WhatsApp
                    </a>
                  </>
                ) : (
                  <>
                    <FaPhoneAlt className="text-[#a30000]" />
                    <a
                      href={callLink()}
                      className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                    >
                      Call us directly — {callNumber}
                    </a>
                  </>
                )}
              </p>
              {whatsappEnabled && callEnabled && (
                <p className="mb-2.5 flex items-center gap-2">
                  <FaPhoneAlt className="text-[#a30000]" />
                  <a
                    href={callLink()}
                    className="text-[#ccc] hover:text-[#a30000] transition-colors duration-300"
                  >
                    Call us directly — {callNumber}
                  </a>
                </p>
              )}
              <p className="text-xs opacity-70 mt-1.5">
                Available Mon-Fri, 9am - 6pm PKT
              </p>
            </div>
          </div>

          {/* SEO Rishta Directory */}
          <div className="border-t border-[#333] pt-8 mb-8">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-6">
              <div>
                <h4 className="text-white text-xs font-bold uppercase tracking-wider mb-3">By Profession</h4>
                <ul className="space-y-1.5">
                  {[
                    ["Doctor Rishta", "/doctor-rishta"],
                    ["Engineer Rishta", "/engineer-rishta"],
                    ["Educated Rishta", "/educated-rishta"],
                    ["Army Rishta", "/army-rishta"],
                  ].map(([label, path]) => (
                    <li key={path}>
                      <Link to={path} className="text-[#999] hover:text-[#a30000] text-xs transition-colors duration-300">
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-white text-xs font-bold uppercase tracking-wider mb-3">Overseas</h4>
                <ul className="space-y-1.5">
                  {[
                    ["Pakistani Rishta", "/pakistani-rishta"],
                    ["Overseas Pakistani", "/overseas-pakistani-rishta"],
                    ["UK Pakistani Rishta", "/uk-pakistani-rishta"],
                    ["USA Pakistani Rishta", "/usa-pakistani-rishta"],
                    ["Canada Pakistani Rishta", "/canada-pakistani-rishta"],
                    ["Australia Pakistani Rishta", "/australia-pakistani-rishta"],
                    ["Saudi Arabia Pakistani Rishta", "/saudi-arabia-pakistani-rishta"],
                    ["Dubai / UAE Pakistani Rishta", "/dubai-pakistani-rishta"],
                    ["Muslim Matrimony", "/muslim-matrimony"],
                  ].map(([label, path]) => (
                    <li key={path}>
                      <Link to={path} className="text-[#999] hover:text-[#a30000] text-xs transition-colors duration-300">
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-white text-xs font-bold uppercase tracking-wider mb-3">Resources</h4>
                <ul className="space-y-1.5">
                  {[
                    ["All Profiles", "/all-profiles"],
                    ["Blog", "/blogs"],
                    ["Pricing Plans", "/pricing"],
                    ["How We're Different", "/how-we-are-different"],
                    ["FAQ", "/faq"],
                    ["About Us", "/about"],
                    ["Partner Program", "/partners/apply"],
                    ["Contact Us", "/contact"],
                  ].map(([label, path]) => (
                    <li key={path}>
                      <Link to={path} className="text-[#999] hover:text-[#a30000] text-xs transition-colors duration-300">
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="text-center border-t border-[#333] pt-5 text-xs text-[#777]">
            <p>© {currentYear} Select Proposal. All rights reserved.</p>
            <p className="mt-2">
              <Link to="/partners/apply" className="text-[#999] hover:text-[#a30000] transition-colors duration-300">
                Become a Partner
              </Link>
              <span className="mx-2 text-[#444]">|</span>
              <Link to="/partners/login" className="text-[#999] hover:text-[#a30000] transition-colors duration-300">
                Partner Login
              </Link>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;